import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Select,Drawer, Typography, Icon, Menu, Button, Modal, message, Tabs,Input} from 'antd';
import {klicountrynames} from '../../stores/APIEndpoints';
import TitleBar from '../TitleBar';
import About from '../About';
import SummaryTable from './SummaryTable';
import {appStore} from '../../stores/AppStore';
import DynamicForm from "../DynamicForm";
import AgGrid from "../AgGrid";
import store from "../../stores/DashboardMessageFromPartnerStore";
import LooseLeafSchedulerDrawer from "../looseLeaf/LooseLeafScheduleDrawer";
import LooseLeafChasingUnits from "../looseLeaf/LooseLeafChasingUnits";
import LooseLeafPeopleDrawer from "../looseLeaf/LooseLeafPeopleDrawer";
import LooseLeafPrimaryInformationDrawer from "../looseLeaf/LooseLeafPrimaryInformationDrawer";
import LooseLeafDrawer from "../looseLeaf/LooseLeafDrawer";
import LooseLeafConfiguration from "../looseLeaf/LooseLeafConfiguration";
import LooseLeafLapsCallLogs from '../looseLeaf/LooseLeafLapsCallLogs';
import { withRouter } from "react-router-dom";
import {messagefromparneridentifierUrl} from "../../stores/APIEndpoints";
import Api from "../../stores/APIEndpoints";
const { TabPane } = Tabs;


const {Text} = Typography;
const {confirm} = Modal;

@observer
class MessageFromPartners extends Component {
    state = {
        deleteModalLoading: false,
       
    };

    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            current: 'AllAcquisition',
            pageId: "1",
            identifier:""
        }
    }
    
    componentDidMount() {
        //store.fetchData();
        store.getPageinfo(this.state.pageId);
        store.clickCustomFilter('all');
    }
    handleClick = values => {
        this.setState({
          current: values.key,
        });
      };
      identifierchange = values =>{
        this.setState({
            identifier: values.target.value,
          });
      }
      arbitratorFilter=()=>{ this.props.history.push("/arbitratorprofile");}
      bookFilter=()=>{ this.props.history.push("/books");}
      dashFilter=()=>{ this.props.history.push("/");}
    render() {
       
        return (
            <div style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                height: '100%'
            }}>
               
                <TitleBar/>
                
                <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
                    <Menu.Item key="MessageFromPartners" onClick={()=>store.clickCustomFilter('all')} >
                    <Icon type="home"/>
                        Message From Partners
                    </Menu.Item>
                    <Menu.Item key="dashboard" onClick={this.dashFilter} >
                    <Icon type="home"/>
                         Looseleaf Dashboard
                    </Menu.Item> 
                    <Menu.Item key="Arbitrator" onClick={this.arbitratorFilter}>
                    <Icon type="home" theme="twoTone"  twoToneColor="red"   />
                        Arbitrator Profile Dashboard
                    </Menu.Item>
                    <Menu.Item key="Books" onClick={this.bookFilter} >
                    <Icon type="home"/>
                         Books Dashboard
                    </Menu.Item> 
                    <Menu.Item key="Configuration">
                    <Icon type="setting" />
                         Configuration
                    </Menu.Item>
                    <Menu.Item key="AboutUs">
                    <Icon type="idcard" />
                         About Us
                    </Menu.Item>

                </Menu>
                {this.state.current != 'AboutUs' && this.state.current != 'Configuration' ?
                <Menu  selectedKeys={[this.state.current]} mode="horizontal" >
                    <Menu.Item >
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <Text  style={{ marginRight:'5px'}}>Page </Text>
                            <Select value={this.state.pageId} onChange={(value)=>{
                                this.setState({pageId:value,identifier:""})
                                store.getPageinfo(value)}} style={{ width: '100px'}}>
                                <Option value="1">1</Option>
                                <Option value="2">2</Option>
                                <Option value="3">3</Option>
                                <Option value="4">4</Option>
                                <Option value="5">5</Option>
                                <Option value="6">6</Option>
                                <Option value="7">7</Option>
                                <Option value="8">8</Option>
                                <Option value="9">9</Option>
                                <Option value="10">10</Option>
                                <Option value="11">11</Option>
                                <Option value="12">12</Option>
                                <Option value="13">13</Option>
                                <Option value="14">14</Option>
                                <Option value="15">15</Option>
                            </Select>
                            </div>
                        
                        <div style={{marginLeft:'20px'}}>
                            <Text>Identifier      </Text>
                            <Input value = {this.state.identifier} onChange = {this.identifierchange}
                            placeholder="Identifier"
                             />
                            <Button type="primary" onClick={()=>{store.getIdentifierinfo(this.state.identifier)}} style={{marginLeft:'20px'}} >
                                     Submit
                            </Button>
                        </div>
                        </div>
                    </Menu.Item>
                </Menu>:""}

                {this.state.current != 'AboutUs' && this.state.current != 'Configuration' ?
                
                <AgGrid
                    deltaRowDataMode={true}
                    rowData={store.rowData}
                    columnDefs={store.columnDefs}
                    onGridReady={this.onGridReady}
                    enableSorting={true}
                    enableFilter={true}
                    onCellClicked={this.handleCellClicked}
                    enableColResize={true}
                    getRowNodeId={(data) => data.id}
                />:""}
                {this.state.current == 'AboutUs'? <div><About /></div>:''}
                {/* {this.state.current == 'SummaryTable'? <div></div>:''} */}
                {this.state.current == 'Configuration'? <LooseLeafConfiguration />:''}
               
            </div>
        )
    }

    handleCellClicked = (params) => {
        let copyDublicate = ['fuzzy_id','file_path','partner_name','status','partner_type','message','identifier','created_at'];
        let getDublicates={};
        const {data} = params;
        
        if(data == undefined)
        {
            return false;
        }
        if(params.column.colId == "status")
        {   
                store.activeTab = '0';
                getDublicates['fuzzy_id'] = params.data.fuzzy_id;
                getDublicates['file_path'] = params.data.file_path;
                getDublicates['partner_name'] = params.data.partner_name;
                getDublicates['status'] = params.data.status;
                getDublicates['partner_type'] = params.data.partner_type;
                getDublicates['message'] = params.data.message;
                getDublicates['identifier'] = params.data.identifier;
                getDublicates['created_at'] = params.data.created_at;
            store.setCurrentData(getDublicates);
            console.log(getDublicates);
            
            return false;
        }
//        this.countryChange(params.data.countryId);
        store.setCurrentData(data);
    };
    // countryChange =async(value)=>{
      
    //   const bodyParams = {
    //         "where": [value.toString()],
    //         "limit": "5"
    //   }
    //   let response = await this.apiProxy.asyncPost(klicountrynames, bodyParams);
    //   const option = await response.json();
    //   store.getCountryName=option[0].country;
    // }
    callback=(key)=>{
        console.log(key);
    }
 
    renderDrawer = () => {
        const currentData = store.currentData;
        if (!store.drawerVisible) return null;
        //let data = store.getFormDefs()
        return (
            <Drawer
                title={this.renderDrawerTitle(store.currentData)}
                width={'40%'}
                onClose={store.unfocus}
                visible={store.drawerVisible}>
                <div className={'formContainer'}>
                <Tabs activeKey={store.activeTab} tabPosition='top' onChange={this.onChangeTab}>
                    <TabPane tab="Primary Information" key={"0"}>
                    <LooseLeafPrimaryInformationDrawer dataStore={data}></LooseLeafPrimaryInformationDrawer>
                        {/* <DynamicForm
                            items={data}
                            submitButtonText={'Save'}
                            onSubmit={store.updateItem}
                        /> */}
                    </TabPane>
                    <TabPane tab="People" key={"1"}>
                         <LooseLeafPeopleDrawer dataStore={data}></LooseLeafPeopleDrawer>
                    </TabPane>
                    <TabPane tab="Schedule" key={"2"}>
                         <LooseLeafSchedulerDrawer dataStore={data}></LooseLeafSchedulerDrawer>
                    </TabPane>
                        { currentData.projectId > 0 ?
                    <TabPane tab="Chasing Units" key={"3"}>
                         <LooseLeafChasingUnits dataStore={data}></LooseLeafChasingUnits>
                    </TabPane>:'' }
                    {/* <TabPane tab="Logs" key={"4"}>
                         <LooseLeafLapsCallLogs dataStore={data}></LooseLeafLapsCallLogs>
                    </TabPane> */}
                </Tabs>
                </div>
            </Drawer>
        );
    };

    renderDrawerTitle = item => {
        let {publication, author, status} = item;
        const canDeleteLooseLeaf = status === 'Available' || status === 'Do Not Chase';
        if(author==null)
        {
            author='';
        }
        return (
            <div style={styles.drawerTitleContainer}>
            {publication!=undefined?
            <div style={{color:'#fff'}}>Edit - {`${publication} - ${author}`}</div>:<div style={{color:'#fff'}}>New</div>}
            {
                canDeleteLooseLeaf ?
                    (<span>
                        &#160;&#160;<Icon type="delete" onClick={this.showDeleteConfirmation} theme="twoTone" twoToneColor="#eb2f96"/>
                    </span>) : null
            }
        </div>
        );
    }
}


const styles = {
    drawerTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 30
    },
    dropdown: {
        backgroundcolour : "#000"
    },
    selectItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 30
    },
    section: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        padding: '10px 0px'
    }
};

export default withRouter(MessageFromPartners)
